document.addEventListener('DOMContentLoaded', function() {
  function getHashFromURL() {
    return window.location.hash.substring(1);
  }

  function openAccordionById(accordionId) {
    if (!accordionId) return;
    const accordions = document.querySelectorAll('accordion-custom');
    accordions.forEach(accordion => {
      const detailsElement = accordion.querySelector('details');
      if (detailsElement) {
        if (
          accordion.hasAttribute('open-by-default-on-desktop') ||
          accordion.hasAttribute('open-by-default-on-mobile')
        ) {
          return;
        }
        detailsElement.open = false;
      }
    });
    const accordionElement = document.querySelector(`accordion-custom[id="${accordionId}"]`);
    if (accordionElement) {
      const detailsElement = accordionElement.querySelector('details');
      if (detailsElement) {
        if (!detailsElement.open) {
          detailsElement.open = true;
        }
        setTimeout(() => {
          accordionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
      }
    }
  }

  function checkAndOpenAccordion() {
    const hashId = getHashFromURL();
    if (hashId) openAccordionById(hashId);
  }

  window.addEventListener('hashchange', checkAndOpenAccordion);
  checkAndOpenAccordion();
  setTimeout(checkAndOpenAccordion, 500);
});